import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { MatSnackBar } from '@angular/material';

import { FireDataService } from '../fire-data.service';
import { DialogsService } from '../dialogs.service';


@Component({
  selector: 'app-teacher-lack-report',
  templateUrl: './teacher-lack-report.component.html',
  styleUrls: ['./teacher-lack-report.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class TeacherLackReportComponent implements OnInit {

  mmonthPivot = [9,10,11,12,1,2,3,4,5,6,7,8];
  arrMonth = [];
  reqMonth: string;
  reportType: string;
  report: object;
  snap: any; // two dimensions, contains all info to show, cols and rows
  currentYear: number;
/*
  gridHeaderTeacherLack = [{text: 'Day', cols: 1, rows: 1, color: 'lightgray'},
  {text: 'Docente assente', cols: 2, rows: 1, color: 'lightgray'},{text: 'Docente sostituto', cols: 2, rows: 1, color: 'lightgray'},
  {text: '08:10', cols: 1, rows: 1, color: 'lightgray'},{text: '09:05', cols: 1, rows: 1, color: 'lightgray'},
  {text: '10:00', cols: 1, rows: 1, color: 'lightgray'},{text: '11:10', cols: 1, rows: 1, color: 'lightgray'},
  {text: '12:05', cols: 1, rows: 1, color: 'lightgray'},{text: '12:55', cols: 1, rows: 1, color: 'lightgray'},
  {text: '13:45', cols: 1, rows: 1, color: '#afb8cc'},{text: '14:35', cols: 1, rows: 1, color: '#afb8cc'},
  {text: '15:25', cols: 1, rows: 1, color: '#afb8cc'},{text: '16:15', cols: 1, rows: 1, color: '#afb8cc'},
  {text: 'Tipo di sostituzione', cols: 2, rows: 1, color: 'lightgray'}];

  gridHeaderDailyEvents = [{text: 'Data Reg.', cols: 1, rows: 1, color: 'lightgray'},
  {text: 'Id - type', cols: 1, rows: 1, color: 'lightgray'},{text: 'Description', cols: 3, rows: 1, color: 'lightgray'},
  {text: 'Teacher 1', cols: 2, rows: 1, color: 'lightgray'},{text: 'Teacher 2', cols: 2, rows: 1, color: 'lightgray'},
  {text: 'Start Date', cols: 1, rows: 1, color: 'lightgray'},{text: 'End Date', cols: 1, rows: 1, color: 'lightgray'},
  {text: 'check', cols: 1, rows: 1, color: 'lightgray'},{text: 'Classes', cols: 2, rows: 1, color: 'lightgray'},
  {text: 'Note', cols: 2, rows: 1, color: '#afb8cc'}];
*/
  reportParameters = {
    "tl": {
      "title": "Teacher lack",
      "gridCols": 18,
      "gridRowHeight": "2em",
      "reportCols": 14,
      "fillRowItem": {text: ' ', cols: 1, rows: 1, link:'',color: '#E3F2FD'},
      "gridHeader": [{text: 'Day', cols: 1, rows: 1, color: 'lightgray'},
      {text: 'Docente assente', cols: 2, rows: 1, color: 'lightgray'},{text: 'Docente sostituto', cols: 2, rows: 1, color: 'lightgray'},
      {text: '08:10', cols: 1, rows: 1, color: 'lightgray'},{text: '09:05', cols: 1, rows: 1, color: 'lightgray'},
      {text: '10:00', cols: 1, rows: 1, color: 'lightgray'},{text: '11:10', cols: 1, rows: 1, color: 'lightgray'},
      {text: '12:05', cols: 1, rows: 1, color: 'lightgray'},{text: '12:55', cols: 1, rows: 1, color: 'lightgray'},
      {text: '13:45', cols: 1, rows: 1, color: '#afb8cc'},{text: '14:35', cols: 1, rows: 1, color: '#afb8cc'},
      {text: '15:25', cols: 1, rows: 1, color: '#afb8cc'},{text: '16:15', cols: 1, rows: 1, color: '#afb8cc'},
      {text: 'Tipo*', cols: 1, rows: 1, color: 'lightgray'},{text: 'Firma**', cols: 2, rows: 1, color: 'lightgray'}],
      "gridLegendaCols": 13,
      "gridLegendaRowHeight": "1.5em", 
      "gridLegenda": [[{cols: 2, class:'', icon: '', text: '', description:'*Tipo di sostituzione'},{cols: 2, class:'', icon: '', text: '', description:''},
      {cols: 7, class:'', icon: '', text: '', description:'**Firma del docente che sostituisce o del docente che riceve la comunicazione'},
      {cols: 2, class:'', icon: '', text: '', description:''}],
      [{cols: 1, class:'', icon: '', text: '', description:'D'},
      {cols: 10, class:'text-inside-grid', icon: '', text: '', description:'Disposizione'},
      {cols: 2, class:'', icon: '', text: '', description:''}],
      [{cols: 1, class:'', icon: '', text: '', description:'S'},
      {cols: 10, class:'text-inside-grid', icon: '', text: '', description:'Sostegno'},
      {cols: 2, class:'', icon: '', text: '', description:''}],
      [{cols: 1, class:'', icon: '', text: '', description:'SP'},
      {cols: 10, class:'text-inside-grid', icon: '', text: '', description:'Supplenza a pagamento'},
      {cols: 2, class:'', icon: '', text: '', description:''}],
      [{cols: 1, class:'', icon: '', text: '', description:'RE'},
      {cols: 10, class:'text-inside-grid', icon: '', text: '', description:'Recupero'},
      {cols: 2, class:'', icon: '', text: '', description:''}],
      [{cols: 1, class:'', icon: '', text: '', description:'RA'},
      {cols: 10, class:'text-inside-grid', icon: '', text: '', description:'Recupero Anticipato'},
      {cols: 2, class:'', icon: '', text: '', description:''}],
      [{cols: 1, class:'', icon: '', text: '', description:'DC'},
      {cols: 10, class:'text-inside-grid', icon: '', text: '', description:'Divisione classe'},
      {cols: 2, class:'', icon: '', text: '', description:''}],
      [{cols: 1, class:'', icon: '', text: '', description:'EC'},
      {cols: 10, class:'text-inside-grid', icon: '', text: '', description:'Entrata posticipata classe'},
      {cols: 2, class:'', icon: '', text: '', description:''}],
      [{cols: 1, class:'', icon: '', text: '', description:'UC'},
      {cols: 10, class:'text-inside-grid', icon: '', text: '', description:'Uscita anticipata classe'},
      {cols: 2, class:'', icon: '', text: '', description:''}]]
    },
    "ev": {
      "title": "Daily events",
      "gridCols": 16,
      "gridRowHeight": "3em",
      "reportCols": 10,
      "fillRowItem": {text: ' ', cols: 1, rows: 1, link:'',color: '#E3F2FD'},
      "gridHeader": [{text: 'Start Date', cols: 1, rows: 1, color: 'lightgray'},{text: 'End Date', cols: 1, rows: 1, color: 'lightgray'},
      {text: 'Data Reg.', cols: 1, rows: 1, color: 'lightgray'},
      {text: 'Id - type', cols: 1, rows: 1, color: 'lightgray'},{text: 'Description', cols: 2, rows: 1, color: 'lightgray'},
      {text: 'Teacher 1', cols: 2, rows: 1, color: 'lightgray'},{text: 'Teacher 2', cols: 2, rows: 1, color: 'lightgray'},
      {text: 'check', cols: 1, rows: 1, color: 'lightgray'},{text: 'Classes', cols: 3, rows: 1, color: 'lightgray'},
      {text: 'Note', cols: 2, rows: 1, color: '#afb8cc'}],
      "titleLegenda": "",
      "gridLegenda": []
    }
  };

  constructor(private fds: FireDataService, private router: Router, private route: ActivatedRoute, private location: Location, 
    private dialogsService: DialogsService, public snackBar: MatSnackBar) { 
      this.snap = [];
      this.currentYear = this.fds.currentYear
    }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.reportType = params["type"] || '';
      this.reqMonth = params["month"] || '';
      this.report = this.reportParameters[this.reportType]
      if (this.arrMonth.length == 0) {
        var tt = this.mmonthPivot ;
        var mm = this.arrMonth;
              for (let i=0; i < tt.length; i++) {
                if (tt[i] == 1) {this.currentYear++}
                var dLoc = new Date(this.currentYear+'-' + tt[i] + '-' + '01')
                mm.push(dLoc.toLocaleDateString('it-IT', {month:'short', year: '2-digit'})+' '+dLoc.toLocaleDateString('it-IT', {month:'2-digit', year: 'numeric'}))
              }
      }
      if(this.reportType == 'tl' && this.reqMonth) {
        this.snap = []
        this.buildReportTeacherLack(this.reqMonth, this.report)
        .then(res =>{
          this.snap = res;
        });
      }
      if(this.reportType == 'ev' && this.reqMonth) {
        this.snap = []
        this.buildReportEvents(this.reqMonth, this.report)
        .then(res =>{
          this.snap = res;
        });
      }
    });
  }
  
private buildReportTeacherLack(reqMonth, report) {
  return new Promise((resolve) => { 
    var snap = [];
    snap.push(report.gridHeader);
    var fillRow = [];
    for (var i in report.gridHeader) {
      var item = Object.assign({},report.fillRowItem)
      item.cols = report.gridHeader[i].cols;
      fillRow.push(item)
    }
    this.fds.getMontlyReplacement(reqMonth, fillRow)
    .then(res => {
      
      for (var i in res) {
        let d = new Date(res[i][0]['text']);
        res[i][0]['text'] = d.toLocaleDateString('it-IT', {day:'2-digit', weekday:'short' });
        res[i][0]['text'] = res[i][0]['text'].substr(4,2)+' '+res[i][0]['text'].substr(0,3)
        res[i][1]['link'] = '/teacher/' + res[i][1]['text'].substr(3) + '/' + res[i][1]['text'].substr(0,1);
        res[i][2]['link'] = '/teacher/' + res[i][2]['text'].substr(3) + '/' + res[i][2]['text'].substr(0,1);
        if(res[i][1]['text'].substr(0,1) == 'S') {res[i][1]['text'] = '(S) ' + res[i][1]['text'].substr(3)}
        else {res[i][1]['text'] = res[i][1]['text'].substr(3)}
        if(res[i][2]['text'].substr(0,1) == 'S') {res[i][2]['text'] = '(S) ' + res[i][2]['text'].substr(3)}
        else {
          if (res[i][2]['text'].substr(0,1) == 'G') {res[i][2]['text'] = ''}
          else {res[i][2]['text'] = res[i][2]['text'].substr(3)}
        }
        if (res[i][13]['text'].length > 2) {res[i][13]['text'] = res[i][13]['text'].substr(0,2)}
        snap.push(res[i])
      }
      resolve (snap)
    });
  });
}

private buildReportEvents(reqMonth, report) {
  return new Promise((resolve) => { 
    var snap = [];
    snap.push(report.gridHeader);
    var fillRow = [];
    for (var i in report.gridHeader) {
      var item = Object.assign({},report.fillRowItem)
      item.cols = report.gridHeader[i].cols;
      fillRow.push(item)
    }
    this.fds.getMontlyCaseData (reqMonth, fillRow)
    .then(res => {
      for (var i in res) {
        let d = new Date(res[i][0]['text']);
        res[i][0]['text'] = d.toLocaleDateString('it-IT', {day:'2-digit', month:'short'});
        if (res[i][5]['text']) {
          res[i][5]['link'] = '/teacher/' + res[i][5]['text'].substr(3) + '/' + res[i][5]['text'].substr(0,1)
          if(res[i][5]['text'].substr(0,1) == 'S') {res[i][5]['text'] = '(S) ' + res[i][5]['text'].substr(3)}
          else {res[i][5]['text'] = res[i][5]['text'].substr(3)}
        }
        if (res[i][6]['text']) {
          res[i][6]['link'] = '/teacher/' + res[i][6]['text'].substr(3) + '/' + res[i][6]['text'].substr(0,1)
          if(res[i][6]['text'].substr(0,1) == 'S') {res[i][6]['text'] = '(S) ' + res[i][6]['text'].substr(3)}
          else {res[i][6]['text'] = res[i][6]['text'].substr(3)}
        }
        let d1 = new Date(res[i][1]['text']);
        res[i][1]['text'] = d1.toLocaleDateString('it-IT', {day:'2-digit', month:'short'});
        let d2 = new Date(res[i][2]['text']);
        res[i][2]['text'] = d2.toLocaleDateString('it-IT', {day:'2-digit', month:'short'});
        res[i][8]['text'] = this.classToString(res[i][8]['text'])
        snap.push(res[i])
      }
      resolve (snap)
    });
  });
}

private classToString(value){
  var classesString = '';
  for (var h in value) {
    classesString = classesString +' '+h+' '+value[h]+', '
  }
  if (classesString.length > 2) {classesString = classesString.substr(0,classesString.length-2)}
  //if (classesString.length > 36) {classesString = classesString.substr(0,32) + '...'}
  return classesString
}

public goBack() {
  this.location.back();

}

  // end class definition
}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/teacher-lack-report/teacher-lack-report.component.ts